import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import HomePage from './pages/HomePage.vue'

// Импорт стилей
import './styles/tailwind.css'
import './styles/atomic.css'

// Создание роутера
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage,
      meta: {
        title: 'TOUCH - Оставь свой отпечаток в музыкальной индустрии',
        description: 'Мультифункциональное приложение для артистов в Telegram. Загружай треки, получай роялти, развивай карьеру.'
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    console.log('🔄 [ROUTER] scrollBehavior called')
    console.log('🔄 [ROUTER] From:', from.fullPath, 'To:', to.fullPath)
    console.log('🔄 [ROUTER] Hash:', to.hash)
    console.log('🔄 [ROUTER] Saved position:', savedPosition)
    
    if (savedPosition) {
      console.log('✅ [ROUTER] Returning saved position:', savedPosition)
      return savedPosition
    } else if (to.hash) {
      console.log('⚠️ [ROUTER] Hash detected:', to.hash, '- PREVENTING auto scroll')
      // Не скроллим автоматически к хешу при загрузке страницы
      // Только если это не первая загрузка
      if (from.name) {
        console.log('✅ [ROUTER] Navigation between pages - scrolling to hash')
        return {
          el: to.hash,
          behavior: 'smooth'
        }
      } else {
        console.log('🚫 [ROUTER] Initial page load - NOT scrolling to hash')
        return { top: 0 }
      }
    } else {
      console.log('✅ [ROUTER] No hash - scrolling to top')
      return { top: 0 }
    }
  }
})

// Обновление мета-тегов при смене роута
router.beforeEach((to, _from, next) => {
  if (to.meta?.title) {
    document.title = to.meta.title as string
  }
  
  if (to.meta?.description) {
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', to.meta.description as string)
    }
  }
  
  next()
})

// Создание приложения
const app = createApp(App)

// Подключение роутера
app.use(router)

// Монтирование приложения
app.mount('#app')







